jQuery(document).ready ($) ->
	$selects = $ 'select:not(.ractive)'
	unless $selects.length > 0
		return

	$selects.selectric
		arrowButtonMarkup: '<b class="btn">&#9662;</b>'
		labelBuilder: (currItem) ->
			imageSrc = currItem.element.data 'image'
			return currItem.text unless imageSrc

			if currItem.value.length
				'<img class="ico" src="' + imageSrc + '"></span>' + currItem.text
			else
				currItem.text
		optionsItemBuilder: (itemData, element) ->
			imageSrc = element.data 'image'
			return itemData.text unless imageSrc

			if element.val().length
				'<img class="ico" src="' + imageSrc + '"></span>' + itemData.text
			else
				itemData.text


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/selectric.coffee
 **/